import React from 'react';
import NumericTextField, {
  type NumericTextFieldProps,
} from './NumericTextField';

export type CustomCurrencyInputProps = NumericTextFieldProps;

const CustomCurrencyInput: React.FC<CustomCurrencyInputProps> = (props) => {
  return <NumericTextField {...props} />;
};

export default CustomCurrencyInput;
